<script lang="ts" setup>
  import { useRoute } from 'vue-router';
  import {useSeoData} from "~/composables/use-seo";

  const props = defineProps<{
        page: any
    }>();
  const route = useRoute();
  const page = props?.page;
  const sections = page?.pageBuilder?.sections;

  useSeoData(props?.page?.seo);
</script>
<template>
  <div  id="nav-stopper" :class="`${page?.pageBuilder?.background?.showBackgroundImage ? 'bg-'+page?.pageBuilder?.background?.backgroundType[0] : ''}`">
    <div v-if="page?.pageBuilder?.headerCoverDetails?.backgroundType[0] !== 'wh_logo'" class="section-spacer"></div>
    <template v-for="(section,index) in sections">
      <ImageHeroSlider v-if="section?.__typename === 'PageBuilderSectionsHeroImageLayout'" 
        :isReversed="section?.isReversed" 
        :slides="section?.slides" 
        :sliderId="`slider${index}`"/>
      <TitleBlock v-if="section?.__typename === 'PageBuilderSectionsTitleBlockLayout'" v-bind="section"/>
      <ImageLinkGroup v-if="section?.__typename === 'PageBuilderSectionsImageLinkGroupLayout'" v-bind="section"/>
      <Headline v-if="section?.__typename === 'PageBuilderSectionsHeadlineLayout'" v-bind="section"/>
      <Slider v-if="section?.__typename === 'PageBuilderSectionsGalleryLayout'" v-bind="section"/>
      <ClientReviews v-if="section?.__typename === 'PageBuilderSectionsClientReviewsLayout'" />
      <ContactForm :class="`${index === (sections.length - 1) ? 'last-contact-form' : 'contact-form'}`" v-if="section?.__typename === 'PageBuilderSectionsContactFormLayout'" v-bind="section"/>
      <Newsletter v-if="section?.__typename === 'PageBuilderSectionsNewsletterLayout'" v-bind="section"/>
      <HomeDesign v-if="section?.__typename === 'PageBuilderSectionsHomeDesignBlockLayout'" v-bind="section" />
      <Accordion v-if="section?.__typename === 'PageBuilderSectionsAccordionLayout'" v-bind="section" />
      <ImageHeroSection v-if="section?.__typename === 'PageBuilderSectionsHeroImageSectionLayout'" v-bind="section"/>
      <CollectionBlock v-if="section?.__typename === 'PageBuilderSectionsCollectionBlockLayout'" v-bind="section"/>
      <ImageModal v-if="section?.__typename === 'PageBuilderSectionsImageModalBlockLayout'" v-bind="section"/>
      <RichTextBlock v-if="section?.__typename === 'PageBuilderSectionsRichTextBlockLayout'" v-bind="section"/>
      <HouseAndLandPackagesGrid v-if="section?.__typename === 'PageBuilderSectionsHlpGridLayout'" v-bind="section"/>
      <template v-if="section?.__typename === 'PageBuilderSectionsBoxSliderLayout'">
        <template v-for="(boxSlider, index2) in section?.slider">
          <BoxSlider :class="`box-slider box-slider-${index2} ${section?.slider.length > 1 && index2 === section?.slider?.length && !section?.addBackgroundColor ? 'box-slider-spacer' : ''}`" 
            v-if="section?.__typename === 'PageBuilderSectionsBoxSliderLayout'" 
            :sliderId="`box-slider-${index2}`" v-bind="boxSlider"
            :addBackgroundColor="section?.addBackgroundColor"
            :style="`${section?.slider.length > 1 && index2 === 0 ? 'padding-bottom: 0px !important;': (index === 0 && index2 === 0 ? 'margin-top: -3rem' : '')}`"
          />
        </template>
      </template>
      <div v-if="(index === (sections.length - 1) && (sections.length - 1 === index && page?.pageBuilder?.addBottomSpacer))" class="desktop-section-spacer" :data-index="index"></div>
      <div v-else-if="(index !== (sections.length - 1) || (sections.length - 1 === index && page?.pageBuilder?.addBottomSpacer))" class="section-spacer" :data-index="index"></div>
    </template>
  </div>
</template>
